import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'
import DashboardView from '@/views/DashboardView.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { title: 'Login - ClassMom', public: true }
  },
  {
    path: '/dashboard',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: DashboardView,
        meta: { title: 'Admin Dashboard - ClassMom', requiresAuth: true }
      },
      {
        path: 'agents',
        name: 'agents',
        component: () => import('@/views/AgentsView.vue'),
        meta: { title: 'Agents - ClassMom', requiresAuth: true }
      },
      {
        path: 'agents/:id',
        name: 'agent-detail',
        component: () => import('@/views/AgentDetailView.vue'),
        meta: { title: 'Agent Detail - ClassMom', requiresAuth: true }
      },
      {
        path: 'schools',
        name: 'schools',
        component: () => import('@/views/SchoolsView.vue'),
        meta: { title: 'Schools - ClassMom', requiresAuth: true, requiresSuperAdmin: true }
      },
      {
        path: 'schools/:schoolId',
        name: 'school-detail',
        component: () => import('@/views/SchoolDetailView.vue'),
        meta: { title: 'School Detail - ClassMom', requiresAuth: true }
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/ProfileView.vue'),
        meta: { title: 'My Profile - ClassMom', requiresAuth: true }
      },
      {
        path: 'inbox',
        name: 'inbox',
        component: () => import('@/views/InboxView.vue'),
        meta: { title: 'Inbox - ClassMom', requiresAuth: true }
      },
      {
        path: 'broadcasts',
        name: 'broadcasts',
        component: () => import('@/views/BroadcastView.vue'),
        meta: { title: 'Broadcasts - ClassMom', requiresAuth: true }
      },
      {
        path: 'wa-simulator',
        name: 'wa-simulator',
        component: () => import('@/views/WhatsAppSimulatorView.vue'),
        meta: { title: 'WhatsApp Simulator - ClassMom', requiresAuth: true, requiresSuperAdmin: true }
      },
      {
        path: 'knowledge',
        name: 'knowledge',
        component: () => import('@/views/KbView.vue'),
        meta: { title: 'Knowledge Base - ClassMom', requiresAuth: true }
      },
      {
        path: 'conversations',
        name: 'conversations',
        component: () => import('@/views/ConversationsView.vue'),
        meta: { title: 'Conversations - ClassMom', requiresAuth: true }
      },
      {
        path: 'prospecting',
        name: 'prospecting',
        component: () => import('@/views/ProspectingView.vue'),
        meta: { title: 'School Prospecting - ClassMom', requiresAuth: true }
      },

    ]
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: { title: 'Reset Password - ClassMom', public: true }
  },
  {
    path: '/legal/terms',
    name: 'legal-terms',
    component: () => import('@/views/legal/TermsView.vue'),
    meta: { title: 'Terms & Conditions - ClassMom', public: true }
  },
  {
    path: '/legal/privacy',
    name: 'legal-privacy',
    component: () => import('@/views/legal/PrivacyView.vue'),
    meta: { title: 'Privacy Policy - ClassMom', public: true }
  },
  {
    path: '/legal/refunds',
    name: 'legal-refunds',
    component: () => import('@/views/legal/RefundView.vue'),
    meta: { title: 'Refund Policy - ClassMom', public: true }
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/dashboard'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, _from, next) => {
  document.title = to.meta.title || 'ClassMom'

  if (to.meta.public) return next()

  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) return next({ name: 'login' })

    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        return next({ name: 'login' })
      }
    } catch {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      return next({ name: 'login' })
    }

    if (to.meta.requiresSuperAdmin) {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        if (user.role !== 'super_admin') return next({ name: 'dashboard' })
      } catch {
        return next({ name: 'dashboard' })
      }
    }
  }

  next()
})

export default router
